module.exports = __webpack_public_path__ + "img/wheelchair.895af868.svg";